import type { EnsembleForecast, EnsembleModel } from "rainowls-shared";
interface Snapshot {
  location: string;
  capturedAt: number;
  forecasts: Record<EnsembleModel, EnsembleForecast>;
}
// Local, gitignored captures only. Production always uses the live ensemble service.
const snapshots = import.meta.env.DEV
  ? import.meta.glob<Snapshot>("../dev/ensemble-snapshot.local.json", { eager: true, import: "default" })
  : {};
export const frozenEnsembles = import.meta.env.DEV;
export const ensembleSnapshot = Object.values(snapshots)[0];
export function frozenEnsemble(model: EnsembleModel): EnsembleForecast {
  const forecast = ensembleSnapshot?.forecasts[model];
  if (!forecast) throw new Error("Development ensemble snapshot is missing. Run npm run snapshot:ensembles --workspace rainowls-web -- 45.5152 -122.6784 Portland, then reload.");
  return structuredClone(forecast);
}
